"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html = void 0;
const react_1 = __importDefault(require("react"));
const AppContext_1 = require("./AppContext");
const Html = ({ 
//on the frontend data will not be set yet, but it will be present in the initial HTML as a script tag with JSON-LD inside, with the ID: request-ld
//so here we read that back to the data variable, so that the rendering (of that same <script> tag) will be identical as the backend
title = process.env.APP_NAME, children, customHead, }) => {
    var _a;
    let { assets, requestObject, requestLD } = (0, AppContext_1.useAppContext)();
    return (react_1.default.createElement("html", { lang: "en" },
        ((_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.head) ? (react_1.default.createElement("head", { dangerouslySetInnerHTML: { __html: document.head.innerHTML } })) : (react_1.default.createElement("head", null,
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("meta", { charSet: "utf-8" }),
            react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
            react_1.default.createElement("link", { rel: "shortcut icon", href: "/static/favicon.ico" }),
            react_1.default.createElement("link", { rel: "icon", href: "/static/favicon-144x144.png", sizes: "144x144" }),
            react_1.default.createElement("link", { rel: "icon", href: "/static/favicon-72x72.png", sizes: "72x72" }),
            react_1.default.createElement("link", { rel: "icon", href: "/static/favicon-57x57.png", sizes: "57x57" }),
            react_1.default.createElement("link", { rel: "shortcut icon", href: "/static/favicon-144x144.png", sizes: "144x144" }),
            react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/static/favicon-144x144.png", sizes: "144x144" }),
            react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/static/favicon-72x72.png", sizes: "72x72" }),
            react_1.default.createElement("link", { rel: "apple-touch-icon", href: "/static/favicon-57x57.png", sizes: "57x57" }),
            react_1.default.createElement("link", { rel: "stylesheet", href: assets['main.css'] }),
            customHead,
            react_1.default.createElement("script", { id: "request-ld", type: "application/ld+json", dangerouslySetInnerHTML: { __html: requestLD } }),
            react_1.default.createElement("script", { id: "request-json", type: "application/json", dangerouslySetInnerHTML: { __html: requestObject } }))),
        react_1.default.createElement("body", null,
            react_1.default.createElement("noscript", { dangerouslySetInnerHTML: {
                    __html: `<b>Enable JavaScript to run this app.</b>`,
                } }),
            children,
            react_1.default.createElement("script", { dangerouslySetInnerHTML: {
                    __html: `assetManifest = ${JSON.stringify(assets)};`,
                } }))));
};
exports.Html = Html;
//# sourceMappingURL=Html.js.map